import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@imaginelearning/web-api-core";
export class FlagrService {
    constructor(http, environment) {
        this.http = http;
        this.environment = environment;
        this.baseUrl = this.environment.config.flagrApiUrl;
    }
    // Method to evaluate a single flag
    evaluateFlag(flagKey, entityContext) {
        // Make the HTTP request to the Flagr evaluation endpoint
        return this.http
            .post(`${this.baseUrl}/evaluation`, {
            flagKey: flagKey,
            entityContext: entityContext
        })
            .pipe(map((response) => {
            return response.variantKey === 'on';
        }), catchError((error) => {
            console.error(`Error evaluating flag ${flagKey}:`, error);
            return of(false);
        }));
    }
    static { this.ɵfac = function FlagrService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FlagrService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Environment)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FlagrService, factory: FlagrService.ɵfac, providedIn: 'root' }); }
}
